<template>
  <div
    id="kt_header_mobile"
    class="header-mobile align-items-center"
    :class="[headerClasses, { 'sa-header-mobile': isSuperAdmin, 'biz-header-mobile': !isSuperAdmin }]"
  >
    <template v-if="isSuperAdmin">
      <div class="sa-m-left">
        <button
          v-if="asideEnabled"
          type="button"
          class="sa-m-burger"
          id="kt_aside_mobile_toggle"
          aria-label="Open menu"
          @click="toggleMobileMenu"
        >
          <i class="mdi mdi-menu"></i>
        </button>
        <div class="sa-m-title">Super Admin</div>
      </div>
      <div class="sa-m-right">
        <button type="button" class="sa-m-avatar" @click="openSaQuickUser" title="Profile">
          SA
        </button>
      </div>
    </template>
    <template v-else>
      <div class="biz-m-left">
        <button
          v-if="asideEnabled"
          type="button"
          class="biz-m-burger"
          id="kt_aside_mobile_toggle"
          aria-label="Open menu"
          @click="toggleMobileMenu"
        >
          <i class="mdi mdi-menu"></i>
        </button>
        <div class="biz-m-title">{{ businessName }}</div>
      </div>
      <div class="biz-m-right">
        <button
          v-if="$store.state.auth.normal && !isAgentUser"
          type="button"
          class="biz-m-icon-btn"
          title="View Website"
          aria-label="View Website"
          @click="takeMeToWeb"
        >
          <i class="fa fa-globe" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="biz-m-icon-btn"
          title="Profile"
          aria-label="Profile"
          @click="openBizQuickUser"
        >
          <i class="mdi mdi-account"></i>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { authGet } from "@/core/services/auth-storage";

export default {
  name: "KTHeaderMobile",
  mounted() {
    this.$nextTick(() => {
      document.addEventListener('click', (e) => {
        if (e.target.closest('.aside-menu a') || e.target.closest('.aside-menu button')) {
          this.closeMobileMenu();
        }
      });
    });
  },
  methods: {
    openSaQuickUser() {
      const panel = document.querySelector('#kt_header #kt_quick_user') || document.getElementById('kt_quick_user');
      if (!panel) return;
      if (panel.classList.contains('offcanvas-on')) {
        this.closeQuickUser();
      } else {
        this.closeMobileMenu();
        panel.classList.add('offcanvas-on');
        panel.style.setProperty('display', 'block', 'important');
        panel.style.setProperty('transform', 'translateX(0)', 'important');
        panel.style.setProperty('visibility', 'visible', 'important');
        panel.style.setProperty('pointer-events', 'auto', 'important');
        panel.style.setProperty('z-index', '10080', 'important');
        document.body.classList.add('quick-user-open');
        this.addUserOverlay();
      }
    },
    closeQuickUser() {
      const panel = document.querySelector('#kt_header #kt_quick_user') || document.getElementById('kt_quick_user');
      if (panel) {
        panel.classList.remove('offcanvas-on');
        panel.style.removeProperty('display');
        panel.style.removeProperty('transform');
        panel.style.removeProperty('visibility');
        panel.style.removeProperty('pointer-events');
        panel.style.removeProperty('z-index');
      }
      document.body.classList.remove('quick-user-open');
      this.removeUserOverlay();
    },
    addUserOverlay() {
      this.removeUserOverlay();
      const overlay = document.createElement('div');
      overlay.className = 'quick-user-overlay';
      overlay.addEventListener('click', () => {
        this.closeQuickUser();
      });
      document.body.appendChild(overlay);
    },
    removeUserOverlay() {
      const overlay = document.querySelector('.quick-user-overlay');
      if (overlay) {
        overlay.remove();
      }
    },
    openBizQuickUser() {
      this.openSaQuickUser();
    },
    takeMeToWeb() {
      const url = this.currentUserPersonalInfo && this.currentUserPersonalInfo.store_url;
      if (url) {
        window.open(url, '_blank');
      }
    },
    toggleMobileMenu() {
      document.body.classList.toggle('mobile-toggle-active');
      const aside = document.getElementById('kt_aside');
      if (aside) {
        aside.classList.toggle('offcanvas-on');
        if (aside.classList.contains('offcanvas-on')) {
          this.addOverlay();
        } else {
          this.removeOverlay();
        }
      }
    },
    closeMobileMenu() {
      document.body.classList.remove('mobile-toggle-active');
      const aside = document.getElementById('kt_aside');
      if (aside) {
        aside.classList.remove('offcanvas-on', 'aside-on');
      }
      this.removeOverlay();
    },
    addOverlay() {
      this.removeOverlay();
      const overlay = document.createElement('div');
      overlay.className = 'aside-offcanvas-overlay';
      overlay.addEventListener('click', () => {
        this.closeMobileMenu();
      });
      const aside = document.getElementById('kt_aside');
      if (aside && aside.parentNode) {
        aside.parentNode.insertBefore(overlay, aside.nextSibling);
      } else {
        document.body.appendChild(overlay);
      }
    },
    removeOverlay() {
      const overlay = document.querySelector('.aside-offcanvas-overlay');
      if (overlay) {
        overlay.remove();
      }
    }
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses", "currentUserPersonalInfo"]),
    isSuperAdmin() {
      return this.$store.state.auth.isAuthenticated && !this.$store.state.auth.normal;
    },
    isAgentUser() {
      return authGet('is_agent') === '1';
    },
    businessName() {
      return (this.currentUserPersonalInfo && this.currentUserPersonalInfo.business_name) || 'Business';
    },
    headerLogo() {
      return (
        process.env.VUE_APP_API_BASE_URL +
        this.$store.state.profile.user_personal_info.logo
      );
    },
    headerClasses() {
      const classes = this.getClasses("header_mobile");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    }
  }
};
</script>

<style>
.header-mobile {
  width: 100vw !important;
  max-width: 100vw !important;
  margin: 0 !important;
  left: 0 !important;
  right: 0 !important;
  box-sizing: border-box !important;
  border-radius: 0 !important;
}

.sa-header-mobile.header-mobile {
  background: #ffffff !important;
  border-bottom: 1px solid #eef1f6 !important;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04) !important;
  padding: 0 14px !important;
  height: 56px !important;
  align-items: center !important;
  justify-content: space-between !important;
  z-index: 1000 !important;
}

.biz-header-mobile.header-mobile {
  background: #ffffff !important;
  border-bottom: 1px solid #eef1f6 !important;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04) !important;
  padding: 0 14px !important;
  height: 56px !important;
  align-items: center !important;
  justify-content: space-between !important;
  z-index: 1000 !important;
  display: flex !important;
}

.biz-m-left,
.biz-m-right {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  min-width: 0 !important;
}

.biz-m-left {
  flex: 1 1 auto !important;
}

.biz-m-right {
  flex: 0 0 auto !important;
  margin-left: auto !important;
}

.biz-m-burger {
  width: 40px !important;
  height: 40px !important;
  border: 1px solid #e2e8f0 !important;
  background: #f8fafc !important;
  border-radius: 10px !important;
  color: #0f172a !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  flex-shrink: 0 !important;
}

.biz-m-burger i {
  font-size: 22px !important;
  color: #0f172a !important;
}

.biz-m-title {
  font-size: 15px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
  letter-spacing: -0.02em !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 46vw !important;
}

.biz-m-icon-btn {
  width: 40px !important;
  height: 40px !important;
  border-radius: 10px !important;
  border: 1px solid #e2e8f0 !important;
  background: #f8fafc !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  color: #475569 !important;
}

.biz-m-icon-btn i {
  font-size: 18px !important;
  color: #475569 !important;
}

/* Never show mobile SA header on desktop — was causing double top bars */
@media (min-width: 992px) {
  .sa-header-mobile.header-mobile,
  .sa-theme .sa-header-mobile,
  .sa-theme #kt_header_mobile,
  .biz-header-mobile.header-mobile,
  .biz-theme .biz-header-mobile,
  .biz-theme #kt_header_mobile {
    display: none !important;
    height: 0 !important;
    overflow: hidden !important;
    visibility: hidden !important;
    pointer-events: none !important;
  }
}

@media (max-width: 991.98px) {
  .sa-header-mobile.header-mobile,
  .biz-header-mobile.header-mobile {
    display: flex !important;
  }
}

.sa-m-left,
.sa-m-right {
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
}

.sa-m-burger {
  width: 40px !important;
  height: 40px !important;
  border: none !important;
  background: #f8fafc !important;
  border-radius: 10px !important;
  color: #0f172a !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
}

.sa-m-burger i {
  font-size: 24px !important;
  color: #0f172a !important;
}

.sa-m-title {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
  letter-spacing: -0.02em !important;
}

.sa-m-notify {
  position: relative !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 10px !important;
  border: 1px solid #e2e8f0 !important;
  background: #f8fafc !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
}

.sa-m-notify i {
  font-size: 20px !important;
  color: #475569 !important;
}

.sa-m-badge {
  position: absolute !important;
  top: -3px !important;
  right: -3px !important;
  min-width: 16px !important;
  height: 16px !important;
  border-radius: 999px !important;
  background: #241B5A !important;
  color: #fff !important;
  font-size: 9px !important;
  font-weight: 700 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 3px !important;
}

.sa-m-avatar {
  width: 36px !important;
  height: 36px !important;
  border-radius: 50% !important;
  border: none !important;
  background: linear-gradient(135deg, #241B5A, #241B5A) !important;
  color: #fff !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
}

@media (max-width: 991.98px) {
  #kt_header #kt_quick_user.offcanvas-on {
    display: block !important;
    position: fixed !important;
    top: 0 !important;
    right: 0 !important;
    width: min(375px, 100vw) !important;
    height: 100dvh !important;
    z-index: 10080 !important;
    transform: translateX(0) !important;
    visibility: visible !important;
    pointer-events: auto !important;
  }
}
</style>
